<style lang="scss">

</style>

<template>
    <div>
        <div class="uk-width-2-10 uk-width-small-3-10 uk-medium-width-5-10 uk-align-center uk-animation-fade">
            <img :src="env.PUBLIC_LOGO" :alt="env.AGENCY_NAME" class=" uk-align-center">
        </div>
        <div class="uk-container uk-container-center uk-margin-top" id="landing-page">
            <nav class="uk-navbar uk-margin-large-bottom ">
                <a class="uk-navbar-brand uk-hidden-small" href="/">
                    <img v-if="env.FAVICON" :src="env.FAVICON" style="height: 30px; margin: 8px;" alt="Home">
                    <img v-else src="/favicon.ico" alt="Home" height="40">
                </a>

                <ul class="uk-navbar-nav uk-hidden-small" v-if="user">
                    <li :class="{'uk-active': $route.name == 'dashboard'}"> <router-link class="uk-text-capitalize" to="/"> {{ __('global.dashboard') }}</router-link> </li>
                    <li :class="{'uk-active': $route.name == 'inbox' || $route.name == 'messageDetails'}"> <router-link class="uk-text-capitalize" to="/inbox"> {{ __('global.messages') }}</router-link> </li>
                    <li class="uk-margin-small-left">
                        <a class="uk-text-capitalize" href="javascript:" @click="logout">{{ __('global.logout') }}</a>
                    </li>
                </ul>
                <ul class="uk-navbar-nav uk-hidden-small" v-else>
                    <li class="uk-active"> <router-link class="uk-text-capitalize" to="/"> {{ __('global.dashboard') }}</router-link> </li>
                    <li class=""> <a class="uk-text-capitalize" href="/login">{{ __('global.login') }}</a> </li>
                </ul>
                <a href="#offcanvas" class="uk-navbar-toggle uk-visible-small" data-uk-offcanvas></a>
                <div class="uk-text-capitalize uk-navbar-brand uk-navbar-center uk-visible-small"> {{ __('global.menu') }}</div>
            </nav>
        </div>

        <router-view/>

        <!-- MOBILE MENU - LOGGED IN -->
        <div id="offcanvas" class="uk-offcanvas">
            <div class="uk-offcanvas-bar">
                <ul class="uk-nav uk-nav-offcanvas uk-nav-parent-icon" data-uk-nav="{multiple:true}" v-if="user">

                    <li><a href="tel:env.PUBLIC_PHONE"><strong>{{env.AGENCY_NAME}}:</strong> {{env.PUBLIC_PHONE}}</a></li>

                    <li :class="{'uk-active': $route.name == 'dashboard'}"> <router-link class="uk-text-capitalize" to="/"> {{ __('global.dashboard') }}</router-link> </li>
                    <li :class="{'uk-active': $route.name == 'inbox' || $route.name == 'messageDetails'}"> <router-link class="uk-text-capitalize" to="/inbox"> {{ __('global.messages') }}</router-link> </li>
                    <li><a class="uk-text-capitalize" @click="logout">{{ __('global.logout') }}</a></li>
                </ul>
                <ul class="uk-nav uk-nav-offcanvas uk-nav-parent-icon" data-uk-nav="{multiple:true}" v-else>
                    <!-- DEV NOTE: We are making apply active for when they are still in the application phase. Otherwise we take them to My Account -->
                    <li class="uk-active"><a class="uk-text-capitalize" href="/"><i class="uk-icon-pencil-square-o"></i> {{ __('global.apply') }}</a></li>
                    <li><a class="uk-text-capitalize" :href="env.PUBLIC_SITE" target="_blank">{{env.PUBLIC_SITE}}</a></li>

                    <!-- NOTE THAT THE LOGIN DOES NOT OPEN IN A LIGHT BOX ON MOBILE - UI KIT has a but that prevents it from closing off canvase and opening the modal -->




                </ul>
            </div>
        </div>
        <vk-modal @cancel="onCloseLogoutModal" stuck :show.sync="showLogoutModal">
            <vk-modal-title class="uk-text-center">{{ __('global.logout_confirm') }}</vk-modal-title>
            <div class="button-wraper uk-grid uk-width-1-1">
                <a href="javscript:;" class="uk-button uk-button-secondary uk-width-1-2 uk-align-center uk-text-capitalize" @click="onCloseLogoutModal"><i
                    class="a-circle-cross"></i> {{ __('global.cancel') }}
                </a>
                <a href="javscript:;" class="uk-button uk-button-danger uk-width-1-2 uk-align-center uk-text-capitalize" @click="onConfirmLogoutModal"><i
                    class="a-envelope-outgoing"></i> {{ __('global.logout') }}
                </a>
            </div>
        </vk-modal>

    </div>
</template>

<script>
    import { mapState } from 'vuex';

    export default {
        name: "HopeApp",
        computed: {
            ...mapState('App', {
                user: state => state.user,
                permissions: state => state.permissions,
                env: state => state.env,
            })
        },
        mounted() {
            this.getUser();
            this.getPrograms();
        },
        data() {
            return {
                showLogoutModal: false,
            }
        },

        methods: {
            onCloseLogoutModal() {
                this.showLogoutModal = false
            },

            onConfirmLogoutModal() {
                this.onCloseLogoutModal();
                axios.post('/api/hope/logout').then(r => {
                    if(r.data.success) {
                        this.$store.commit('App/SET_USER', { user: null });
                        this.$store.commit('App/SET_PERMISSIONS', { permissions: null });
                        this.$router.replace('/');
                        window.location.reload();
                    }
                })
            },

            async getPrograms() {
                let r = await axios.get('/api/hope/programs');
                this.$store.commit('App/SET_PROGRAMS', r.data);
            },
            getUser() {
                this.$store.dispatch('App/fetchUser');
            },
            logout() {
                this.showLogoutModal = true
            }

        }
    }
</script>

<style scoped lang="scss">
    .button-wraper {
        margin: 40px 0 20px;
        a {
            margin: 0;
        }
    }
</style>
